import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cases_icon_check",
  "use": "cases_icon_check-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"cases_icon_check\"><path d=\"m8.29 12.465-2.207-2.207a.633.633 0 1 0-.897.897l2.66 2.659a.634.634 0 0 0 .896 0l6.731-6.73a.634.634 0 1 0-.897-.898l-6.285 6.28Z\" fill=\"#2C2D2E\" stroke=\"#2C2D2E\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol